// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"eebcee51","450":"617e460d","714":"eebcee51","997":"02a386a4"}[chunkId] + ".chunk.css";
};